var _g;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgZoomBg(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 102,
    height: 172,
    viewBox: "0 0 102 172",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.1
  }, /*#__PURE__*/React.createElement("path", {
    d: "M3.57746e-08 168.866L0.5 168L5.69615 171L5.19615 171.866L3.57746e-08 168.866Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1.31174e-07 160.866L0.5 160L5.69615 163L5.19615 163.866L1.31174e-07 160.866Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2.26573e-07 152.866L0.5 152L5.69615 155L5.19615 155.866L2.26573e-07 152.866Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.21972e-07 144.866L0.5 144L5.69615 147L5.19615 147.866L3.21972e-07 144.866Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.17371e-07 136.866L0.5 136L5.69615 139L5.19615 139.866L4.17371e-07 136.866Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.1277e-07 128.866L0.500001 128L5.69615 131L5.19615 131.866L5.1277e-07 128.866Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.08169e-07 120.866L0.500001 120L5.69615 123L5.19615 123.866L6.08169e-07 120.866Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.03568e-07 112.866L0.500001 112L5.69615 115L5.19615 115.866L7.03568e-07 112.866Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.98967e-07 104.866L0.500001 104L5.69615 107L5.19615 107.866L7.98967e-07 104.866Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.94366e-07 96.866L0.500001 95.9999L5.69615 98.9999L5.19615 99.866L8.94366e-07 96.866Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.89765e-07 88.866L0.500001 87.9999L5.69615 90.9999L5.19615 91.866L9.89765e-07 88.866Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1.08516e-06 80.866L0.500001 79.9999L5.69615 82.9999L5.19615 83.866L1.08516e-06 80.866Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1.18056e-06 72.866L0.500001 71.9999L5.69615 74.9999L5.19615 75.866L1.18056e-06 72.866Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1.27596e-06 64.866L0.500001 63.9999L5.69615 66.9999L5.19615 67.866L1.27596e-06 64.866Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1.37136e-06 56.866L0.500001 55.9999L5.69615 58.9999L5.19615 59.866L1.37136e-06 56.866Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1.46676e-06 48.866L0.500001 47.9999L5.69615 50.9999L5.19615 51.866L1.46676e-06 48.866Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1.56216e-06 40.866L0.500002 39.9999L5.69615 42.9999L5.19615 43.866L1.56216e-06 40.866Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1.65756e-06 32.866L0.500002 31.9999L5.69615 34.9999L5.19615 35.866L1.65756e-06 32.866Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1.75296e-06 24.866L0.500002 23.9999L5.69615 26.9999L5.19615 27.866L1.75296e-06 24.866Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1.84836e-06 16.866L0.500002 15.9999L5.69615 18.9999L5.19615 19.866L1.84836e-06 16.866Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1.94376e-06 8.86596L0.500002 7.99993L5.69615 10.9999L5.19615 11.866L1.94376e-06 8.86596Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2.03915e-06 0.865959L0.500002 -6.86586e-05L5.69615 2.99993L5.19615 3.86596L2.03915e-06 0.865959Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8 168.866L8.5 168L13.6962 171L13.1962 171.866L8 168.866Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8 160.866L8.5 160L13.6962 163L13.1962 163.866L8 160.866Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8 152.866L8.5 152L13.6962 155L13.1962 155.866L8 152.866Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8 144.866L8.5 144L13.6962 147L13.1962 147.866L8 144.866Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8 136.866L8.5 136L13.6962 139L13.1962 139.866L8 136.866Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8 128.866L8.5 128L13.6962 131L13.1962 131.866L8 128.866Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8 120.866L8.5 120L13.6962 123L13.1962 123.866L8 120.866Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8 112.866L8.5 112L13.6962 115L13.1962 115.866L8 112.866Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8 104.866L8.5 104L13.6962 107L13.1962 107.866L8 104.866Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8 96.866L8.5 95.9999L13.6962 98.9999L13.1962 99.866L8 96.866Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8 88.866L8.5 87.9999L13.6962 90.9999L13.1962 91.866L8 88.866Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8 80.866L8.5 79.9999L13.6962 82.9999L13.1962 83.866L8 80.866Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8 72.866L8.5 71.9999L13.6962 74.9999L13.1962 75.866L8 72.866Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8 64.866L8.5 63.9999L13.6962 66.9999L13.1962 67.866L8 64.866Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8 56.866L8.5 55.9999L13.6962 58.9999L13.1962 59.866L8 56.866Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8 48.866L8.5 47.9999L13.6962 50.9999L13.1962 51.866L8 48.866Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8 40.866L8.5 39.9999L13.6962 42.9999L13.1962 43.866L8 40.866Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8 32.866L8.5 31.9999L13.6962 34.9999L13.1962 35.866L8 32.866Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8 24.866L8.5 23.9999L13.6962 26.9999L13.1962 27.866L8 24.866Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8 16.866L8.5 15.9999L13.6962 18.9999L13.1962 19.866L8 16.866Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8 8.86596L8.5 7.99993L13.6962 10.9999L13.1962 11.866L8 8.86596Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8 0.865959L8.5 -6.85632e-05L13.6962 2.99993L13.1962 3.86596L8 0.865959Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16 168.866L16.5 168L21.6962 171L21.1962 171.866L16 168.866Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16 160.866L16.5 160L21.6962 163L21.1962 163.866L16 160.866Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16 152.866L16.5 152L21.6962 155L21.1962 155.866L16 152.866Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16 144.866L16.5 144L21.6962 147L21.1962 147.866L16 144.866Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16 136.866L16.5 136L21.6962 139L21.1962 139.866L16 136.866Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16 128.866L16.5 128L21.6962 131L21.1962 131.866L16 128.866Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16 120.866L16.5 120L21.6962 123L21.1962 123.866L16 120.866Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16 112.866L16.5 112L21.6962 115L21.1962 115.866L16 112.866Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16 104.866L16.5 104L21.6962 107L21.1962 107.866L16 104.866Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16 96.866L16.5 95.9999L21.6962 98.9999L21.1962 99.866L16 96.866Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16 88.866L16.5 87.9999L21.6962 90.9999L21.1962 91.866L16 88.866Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16 80.866L16.5 79.9999L21.6962 82.9999L21.1962 83.866L16 80.866Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16 72.866L16.5 71.9999L21.6962 74.9999L21.1962 75.866L16 72.866Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16 64.866L16.5 63.9999L21.6962 66.9999L21.1962 67.866L16 64.866Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16 56.866L16.5 55.9999L21.6962 58.9999L21.1962 59.866L16 56.866Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16 48.866L16.5 47.9999L21.6962 50.9999L21.1962 51.866L16 48.866Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16 40.866L16.5 39.9999L21.6962 42.9999L21.1962 43.866L16 40.866Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16 32.866L16.5 31.9999L21.6962 34.9999L21.1962 35.866L16 32.866Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16 24.866L16.5 23.9999L21.6962 26.9999L21.1962 27.866L16 24.866Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16 16.866L16.5 15.9999L21.6962 18.9999L21.1962 19.866L16 16.866Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16 8.86596L16.5 7.99993L21.6962 10.9999L21.1962 11.866L16 8.86596Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16 0.865959L16.5 -6.84678e-05L21.6962 2.99993L21.1962 3.86596L16 0.865959Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24 168.866L24.5 168L29.6962 171L29.1962 171.866L24 168.866Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24 160.866L24.5 160L29.6962 163L29.1962 163.866L24 160.866Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24 152.866L24.5 152L29.6962 155L29.1962 155.866L24 152.866Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24 144.866L24.5 144L29.6962 147L29.1962 147.866L24 144.866Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24 136.866L24.5 136L29.6962 139L29.1962 139.866L24 136.866Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24 128.866L24.5 128L29.6962 131L29.1962 131.866L24 128.866Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24 120.866L24.5 120L29.6962 123L29.1962 123.866L24 120.866Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24 112.866L24.5 112L29.6962 115L29.1962 115.866L24 112.866Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24 104.866L24.5 104L29.6962 107L29.1962 107.866L24 104.866Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24 96.866L24.5 95.9999L29.6962 98.9999L29.1962 99.866L24 96.866Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24 88.866L24.5 87.9999L29.6962 90.9999L29.1962 91.866L24 88.866Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24 80.866L24.5 79.9999L29.6962 82.9999L29.1962 83.866L24 80.866Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24 72.866L24.5 71.9999L29.6962 74.9999L29.1962 75.866L24 72.866Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24 64.866L24.5 63.9999L29.6962 66.9999L29.1962 67.866L24 64.866Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24 56.866L24.5 55.9999L29.6962 58.9999L29.1962 59.866L24 56.866Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24 48.866L24.5 47.9999L29.6962 50.9999L29.1962 51.866L24 48.866Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24 40.866L24.5 39.9999L29.6962 42.9999L29.1962 43.866L24 40.866Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24 32.866L24.5 31.9999L29.6962 34.9999L29.1962 35.866L24 32.866Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24 24.866L24.5 23.9999L29.6962 26.9999L29.1962 27.866L24 24.866Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24 16.866L24.5 15.9999L29.6962 18.9999L29.1962 19.866L24 16.866Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24 8.86596L24.5 7.99993L29.6962 10.9999L29.1962 11.866L24 8.86596Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24 0.865959L24.5 -6.83724e-05L29.6962 2.99993L29.1962 3.86596L24 0.865959Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32 168.866L32.5 168L37.6962 171L37.1962 171.866L32 168.866Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32 160.866L32.5 160L37.6962 163L37.1962 163.866L32 160.866Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32 152.866L32.5 152L37.6962 155L37.1962 155.866L32 152.866Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32 144.866L32.5 144L37.6962 147L37.1962 147.866L32 144.866Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32 136.866L32.5 136L37.6962 139L37.1962 139.866L32 136.866Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32 128.866L32.5 128L37.6962 131L37.1962 131.866L32 128.866Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32 120.866L32.5 120L37.6962 123L37.1962 123.866L32 120.866Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32 112.866L32.5 112L37.6962 115L37.1962 115.866L32 112.866Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32 104.866L32.5 104L37.6962 107L37.1962 107.866L32 104.866Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32 96.866L32.5 95.9999L37.6962 98.9999L37.1962 99.866L32 96.866Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32 88.866L32.5 87.9999L37.6962 90.9999L37.1962 91.866L32 88.866Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32 80.866L32.5 79.9999L37.6962 82.9999L37.1962 83.866L32 80.866Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32 72.866L32.5 71.9999L37.6962 74.9999L37.1962 75.866L32 72.866Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32 64.866L32.5 63.9999L37.6962 66.9999L37.1962 67.866L32 64.866Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32 56.866L32.5 55.9999L37.6962 58.9999L37.1962 59.866L32 56.866Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32 48.866L32.5 47.9999L37.6962 50.9999L37.1962 51.866L32 48.866Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32 40.866L32.5 39.9999L37.6962 42.9999L37.1962 43.866L32 40.866Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32 32.866L32.5 31.9999L37.6962 34.9999L37.1962 35.866L32 32.866Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32 24.866L32.5 23.9999L37.6962 26.9999L37.1962 27.866L32 24.866Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32 16.866L32.5 15.9999L37.6962 18.9999L37.1962 19.866L32 16.866Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32 8.86596L32.5 7.99993L37.6962 10.9999L37.1962 11.866L32 8.86596Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32 0.86596L32.5 -6.8277e-05L37.6962 2.99993L37.1962 3.86596L32 0.86596Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40 168.866L40.5 168L45.6962 171L45.1962 171.866L40 168.866Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40 160.866L40.5 160L45.6962 163L45.1962 163.866L40 160.866Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40 152.866L40.5 152L45.6962 155L45.1962 155.866L40 152.866Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40 144.866L40.5 144L45.6962 147L45.1962 147.866L40 144.866Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40 136.866L40.5 136L45.6962 139L45.1962 139.866L40 136.866Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40 128.866L40.5 128L45.6962 131L45.1962 131.866L40 128.866Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40 120.866L40.5 120L45.6962 123L45.1962 123.866L40 120.866Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40 112.866L40.5 112L45.6962 115L45.1962 115.866L40 112.866Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40 104.866L40.5 104L45.6962 107L45.1962 107.866L40 104.866Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40 96.866L40.5 95.9999L45.6962 98.9999L45.1962 99.866L40 96.866Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40 88.866L40.5 87.9999L45.6962 90.9999L45.1962 91.866L40 88.866Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40 80.866L40.5 79.9999L45.6962 82.9999L45.1962 83.866L40 80.866Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40 72.866L40.5 71.9999L45.6962 74.9999L45.1962 75.866L40 72.866Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40 64.866L40.5 63.9999L45.6962 66.9999L45.1962 67.866L40 64.866Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40 56.866L40.5 55.9999L45.6962 58.9999L45.1962 59.866L40 56.866Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40 48.866L40.5 47.9999L45.6962 50.9999L45.1962 51.866L40 48.866Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40 40.866L40.5 39.9999L45.6962 42.9999L45.1962 43.866L40 40.866Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40 32.866L40.5 31.9999L45.6962 34.9999L45.1962 35.866L40 32.866Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40 24.866L40.5 23.9999L45.6962 26.9999L45.1962 27.866L40 24.866Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40 16.866L40.5 15.9999L45.6962 18.9999L45.1962 19.866L40 16.866Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40 8.86596L40.5 7.99993L45.6962 10.9999L45.1962 11.866L40 8.86596Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40 0.86596L40.5 -6.81816e-05L45.6962 2.99993L45.1962 3.86596L40 0.86596Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M48 168.866L48.5 168L53.6962 171L53.1962 171.866L48 168.866Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M48 160.866L48.5 160L53.6962 163L53.1962 163.866L48 160.866Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M48 152.866L48.5 152L53.6962 155L53.1962 155.866L48 152.866Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M48 144.866L48.5 144L53.6962 147L53.1962 147.866L48 144.866Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M48 136.866L48.5 136L53.6962 139L53.1962 139.866L48 136.866Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M48 128.866L48.5 128L53.6962 131L53.1962 131.866L48 128.866Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M48 120.866L48.5 120L53.6962 123L53.1962 123.866L48 120.866Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M48 112.866L48.5 112L53.6962 115L53.1962 115.866L48 112.866Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M48 104.866L48.5 104L53.6962 107L53.1962 107.866L48 104.866Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M48 96.866L48.5 95.9999L53.6962 98.9999L53.1962 99.866L48 96.866Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M48 88.866L48.5 87.9999L53.6962 90.9999L53.1962 91.866L48 88.866Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M48 80.866L48.5 79.9999L53.6962 82.9999L53.1962 83.866L48 80.866Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M48 72.866L48.5 71.9999L53.6962 74.9999L53.1962 75.866L48 72.866Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M48 64.866L48.5 63.9999L53.6962 66.9999L53.1962 67.866L48 64.866Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M48 56.866L48.5 55.9999L53.6962 58.9999L53.1962 59.866L48 56.866Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M48 48.866L48.5 47.9999L53.6962 50.9999L53.1962 51.866L48 48.866Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M48 40.866L48.5 39.9999L53.6962 42.9999L53.1962 43.866L48 40.866Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M48 32.866L48.5 31.9999L53.6962 34.9999L53.1962 35.866L48 32.866Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M48 24.866L48.5 23.9999L53.6962 26.9999L53.1962 27.866L48 24.866Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M48 16.866L48.5 15.9999L53.6962 18.9999L53.1962 19.866L48 16.866Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M48 8.86596L48.5 7.99993L53.6962 10.9999L53.1962 11.866L48 8.86596Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M48 0.86596L48.5 -6.80862e-05L53.6962 2.99993L53.1962 3.86596L48 0.86596Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M56 168.866L56.5 168L61.6962 171L61.1962 171.866L56 168.866Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M56 160.866L56.5 160L61.6962 163L61.1962 163.866L56 160.866Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M56 152.866L56.5 152L61.6962 155L61.1962 155.866L56 152.866Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M56 144.866L56.5 144L61.6962 147L61.1962 147.866L56 144.866Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M56 136.866L56.5 136L61.6962 139L61.1962 139.866L56 136.866Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M56 128.866L56.5 128L61.6962 131L61.1962 131.866L56 128.866Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M56 120.866L56.5 120L61.6962 123L61.1962 123.866L56 120.866Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M56 112.866L56.5 112L61.6962 115L61.1962 115.866L56 112.866Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M56 104.866L56.5 104L61.6962 107L61.1962 107.866L56 104.866Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M56 96.866L56.5 95.9999L61.6962 98.9999L61.1962 99.866L56 96.866Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M56 88.866L56.5 87.9999L61.6962 90.9999L61.1962 91.866L56 88.866Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M56 80.866L56.5 79.9999L61.6962 82.9999L61.1962 83.866L56 80.866Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M56 72.866L56.5 71.9999L61.6962 74.9999L61.1962 75.866L56 72.866Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M56 64.866L56.5 63.9999L61.6962 66.9999L61.1962 67.866L56 64.866Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M56 56.866L56.5 55.9999L61.6962 58.9999L61.1962 59.866L56 56.866Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M56 48.866L56.5 47.9999L61.6962 50.9999L61.1962 51.866L56 48.866Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M56 40.866L56.5 39.9999L61.6962 42.9999L61.1962 43.866L56 40.866Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M56 32.866L56.5 31.9999L61.6962 34.9999L61.1962 35.866L56 32.866Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M56 24.866L56.5 23.9999L61.6962 26.9999L61.1962 27.866L56 24.866Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M56 16.866L56.5 15.9999L61.6962 18.9999L61.1962 19.866L56 16.866Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M56 8.86596L56.5 7.99993L61.6962 10.9999L61.1962 11.866L56 8.86596Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M56 0.86596L56.5 -6.79908e-05L61.6962 2.99993L61.1962 3.86596L56 0.86596Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M64 168.866L64.5 168L69.6962 171L69.1962 171.866L64 168.866Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M64 160.866L64.5 160L69.6962 163L69.1962 163.866L64 160.866Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M64 152.866L64.5 152L69.6962 155L69.1962 155.866L64 152.866Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M64 144.866L64.5 144L69.6962 147L69.1962 147.866L64 144.866Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M64 136.866L64.5 136L69.6962 139L69.1962 139.866L64 136.866Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M64 128.866L64.5 128L69.6962 131L69.1962 131.866L64 128.866Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M64 120.866L64.5 120L69.6962 123L69.1962 123.866L64 120.866Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M64 112.866L64.5 112L69.6962 115L69.1962 115.866L64 112.866Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M64 104.866L64.5 104L69.6962 107L69.1962 107.866L64 104.866Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M64 96.866L64.5 95.9999L69.6962 98.9999L69.1962 99.866L64 96.866Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M64 88.866L64.5 87.9999L69.6962 90.9999L69.1962 91.866L64 88.866Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M64 80.866L64.5 79.9999L69.6962 82.9999L69.1962 83.866L64 80.866Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M64 72.866L64.5 71.9999L69.6962 74.9999L69.1962 75.866L64 72.866Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M64 64.866L64.5 63.9999L69.6962 66.9999L69.1962 67.866L64 64.866Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M64 56.866L64.5 55.9999L69.6962 58.9999L69.1962 59.866L64 56.866Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M64 48.866L64.5 47.9999L69.6962 50.9999L69.1962 51.866L64 48.866Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M64 40.866L64.5 39.9999L69.6962 42.9999L69.1962 43.866L64 40.866Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M64 32.866L64.5 31.9999L69.6962 34.9999L69.1962 35.866L64 32.866Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M64 24.866L64.5 23.9999L69.6962 26.9999L69.1962 27.866L64 24.866Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M64 16.866L64.5 15.9999L69.6962 18.9999L69.1962 19.866L64 16.866Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M64 8.86596L64.5 7.99993L69.6962 10.9999L69.1962 11.866L64 8.86596Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M64 0.86596L64.5 -6.78954e-05L69.6962 2.99993L69.1962 3.86596L64 0.86596Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M72 168.866L72.5 168L77.6962 171L77.1962 171.866L72 168.866Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M72 160.866L72.5 160L77.6962 163L77.1962 163.866L72 160.866Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M72 152.866L72.5 152L77.6962 155L77.1962 155.866L72 152.866Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M72 144.866L72.5 144L77.6962 147L77.1962 147.866L72 144.866Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M72 136.866L72.5 136L77.6962 139L77.1962 139.866L72 136.866Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M72 128.866L72.5 128L77.6962 131L77.1962 131.866L72 128.866Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M72 120.866L72.5 120L77.6962 123L77.1962 123.866L72 120.866Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M72 112.866L72.5 112L77.6962 115L77.1962 115.866L72 112.866Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M72 104.866L72.5 104L77.6962 107L77.1962 107.866L72 104.866Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M72 96.866L72.5 95.9999L77.6962 98.9999L77.1962 99.866L72 96.866Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M72 88.866L72.5 87.9999L77.6962 90.9999L77.1962 91.866L72 88.866Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M72 80.866L72.5 79.9999L77.6962 82.9999L77.1962 83.866L72 80.866Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M72 72.866L72.5 71.9999L77.6962 74.9999L77.1962 75.866L72 72.866Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M72 64.866L72.5 63.9999L77.6962 66.9999L77.1962 67.866L72 64.866Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M72 56.866L72.5 55.9999L77.6962 58.9999L77.1962 59.866L72 56.866Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M72 48.866L72.5 47.9999L77.6962 50.9999L77.1962 51.866L72 48.866Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M72 40.866L72.5 39.9999L77.6962 42.9999L77.1962 43.866L72 40.866Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M72 32.866L72.5 31.9999L77.6962 34.9999L77.1962 35.866L72 32.866Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M72 24.866L72.5 23.9999L77.6962 26.9999L77.1962 27.866L72 24.866Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M72 16.866L72.5 15.9999L77.6962 18.9999L77.1962 19.866L72 16.866Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M72 8.86596L72.5 7.99993L77.6962 10.9999L77.1962 11.866L72 8.86596Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M72 0.86596L72.5 -6.78e-05L77.6962 2.99993L77.1962 3.86596L72 0.86596Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M80 168.866L80.5 168L85.6962 171L85.1962 171.866L80 168.866Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M80 160.866L80.5 160L85.6962 163L85.1962 163.866L80 160.866Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M80 152.866L80.5 152L85.6962 155L85.1962 155.866L80 152.866Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M80 144.866L80.5 144L85.6962 147L85.1962 147.866L80 144.866Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M80 136.866L80.5 136L85.6962 139L85.1962 139.866L80 136.866Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M80 128.866L80.5 128L85.6962 131L85.1962 131.866L80 128.866Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M80 120.866L80.5 120L85.6962 123L85.1962 123.866L80 120.866Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M80 112.866L80.5 112L85.6962 115L85.1962 115.866L80 112.866Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M80 104.866L80.5 104L85.6962 107L85.1962 107.866L80 104.866Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M80 96.866L80.5 95.9999L85.6962 98.9999L85.1962 99.866L80 96.866Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M80 88.866L80.5 87.9999L85.6962 90.9999L85.1962 91.866L80 88.866Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M80 80.866L80.5 79.9999L85.6962 82.9999L85.1962 83.866L80 80.866Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M80 72.866L80.5 71.9999L85.6962 74.9999L85.1962 75.866L80 72.866Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M80 64.866L80.5 63.9999L85.6962 66.9999L85.1962 67.866L80 64.866Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M80 56.866L80.5 55.9999L85.6962 58.9999L85.1962 59.866L80 56.866Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M80 48.866L80.5 47.9999L85.6962 50.9999L85.1962 51.866L80 48.866Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M80 40.866L80.5 39.9999L85.6962 42.9999L85.1962 43.866L80 40.866Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M80 32.866L80.5 31.9999L85.6962 34.9999L85.1962 35.866L80 32.866Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M80 24.866L80.5 23.9999L85.6962 26.9999L85.1962 27.866L80 24.866Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M80 16.866L80.5 15.9999L85.6962 18.9999L85.1962 19.866L80 16.866Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M80 8.86596L80.5 7.99993L85.6962 10.9999L85.1962 11.866L80 8.86596Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M80 0.86596L80.5 -6.77046e-05L85.6962 2.99993L85.1962 3.86596L80 0.86596Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M88 168.866L88.5 168L93.6962 171L93.1962 171.866L88 168.866Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M88 160.866L88.5 160L93.6962 163L93.1962 163.866L88 160.866Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M88 152.866L88.5 152L93.6962 155L93.1962 155.866L88 152.866Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M88 144.866L88.5 144L93.6962 147L93.1962 147.866L88 144.866Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M88 136.866L88.5 136L93.6962 139L93.1962 139.866L88 136.866Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M88 128.866L88.5 128L93.6962 131L93.1962 131.866L88 128.866Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M88 120.866L88.5 120L93.6962 123L93.1962 123.866L88 120.866Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M88 112.866L88.5 112L93.6962 115L93.1962 115.866L88 112.866Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M88 104.866L88.5 104L93.6962 107L93.1962 107.866L88 104.866Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M88 96.866L88.5 95.9999L93.6962 98.9999L93.1962 99.866L88 96.866Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M88 88.866L88.5 87.9999L93.6962 90.9999L93.1962 91.866L88 88.866Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M88 80.866L88.5 79.9999L93.6962 82.9999L93.1962 83.866L88 80.866Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M88 72.866L88.5 71.9999L93.6962 74.9999L93.1962 75.866L88 72.866Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M88 64.866L88.5 63.9999L93.6962 66.9999L93.1962 67.866L88 64.866Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M88 56.866L88.5 55.9999L93.6962 58.9999L93.1962 59.866L88 56.866Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M88 48.866L88.5 47.9999L93.6962 50.9999L93.1962 51.866L88 48.866Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M88 40.866L88.5 39.9999L93.6962 42.9999L93.1962 43.866L88 40.866Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M88 32.866L88.5 31.9999L93.6962 34.9999L93.1962 35.866L88 32.866Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M88 24.866L88.5 23.9999L93.6962 26.9999L93.1962 27.866L88 24.866Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M88 16.866L88.5 15.9999L93.6962 18.9999L93.1962 19.866L88 16.866Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M88 8.86596L88.5 7.99993L93.6962 10.9999L93.1962 11.866L88 8.86596Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M88 0.86596L88.5 -6.76092e-05L93.6962 2.99993L93.1962 3.86596L88 0.86596Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M96 168.866L96.5 168L101.696 171L101.196 171.866L96 168.866Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M96 160.866L96.5 160L101.696 163L101.196 163.866L96 160.866Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M96 152.866L96.5 152L101.696 155L101.196 155.866L96 152.866Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M96 144.866L96.5 144L101.696 147L101.196 147.866L96 144.866Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M96 136.866L96.5 136L101.696 139L101.196 139.866L96 136.866Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M96 128.866L96.5 128L101.696 131L101.196 131.866L96 128.866Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M96 120.866L96.5 120L101.696 123L101.196 123.866L96 120.866Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M96 112.866L96.5 112L101.696 115L101.196 115.866L96 112.866Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M96 104.866L96.5 104L101.696 107L101.196 107.866L96 104.866Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M96 96.866L96.5 95.9999L101.696 98.9999L101.196 99.866L96 96.866Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M96 88.866L96.5 87.9999L101.696 90.9999L101.196 91.866L96 88.866Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M96 80.866L96.5 79.9999L101.696 82.9999L101.196 83.866L96 80.866Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M96 72.866L96.5 71.9999L101.696 74.9999L101.196 75.866L96 72.866Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M96 64.866L96.5 63.9999L101.696 66.9999L101.196 67.866L96 64.866Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M96 56.866L96.5 55.9999L101.696 58.9999L101.196 59.866L96 56.866Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M96 48.866L96.5 47.9999L101.696 50.9999L101.196 51.866L96 48.866Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M96 40.866L96.5 39.9999L101.696 42.9999L101.196 43.866L96 40.866Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M96 32.866L96.5 31.9999L101.696 34.9999L101.196 35.866L96 32.866Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M96 24.866L96.5 23.9999L101.696 26.9999L101.196 27.866L96 24.866Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M96 16.866L96.5 15.9999L101.696 18.9999L101.196 19.866L96 16.866Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M96 8.86596L96.5 7.99993L101.696 10.9999L101.196 11.866L96 8.86596Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M96 0.86596L96.5 -6.75138e-05L101.696 2.99993L101.196 3.86596L96 0.86596Z",
    fill: "white"
  }))));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgZoomBg);
export default __webpack_public_path__ + "static/media/zoomBg.5b683374bef237b05662ad22bcf27838.svg";
export { ForwardRef as ReactComponent };